import React, { useState, useCallback } from "react";

import LoginForm from "./LoginForm";
import ChangePasswordModal from "../AppPage/Header/ChangePasswordModal";

import { OTPModal } from "containers/AppPage/Header/OTPModal";
import { validateLoginOTP } from "app/services/dashboard/mfa.service";
import { login } from "services/auth.service";
import { showErrorToast, showSuccessToast } from "../../utils/toast";
import useAuth from "hooks/useAuth";
import { OTP_BLOCKED_ERROR_CODES } from "static/constants";

const Login = (props) => {
  const [loading, setLoading] = useState(false);
  const [userEmail, setUserEmail] = useState("");
  const [authToken, setAuthToken] = useState("");
  const [alertMessage, setAlertMessage] = useState(null);
  const [resetPasswordModalOpen, setResetPasswordModalOpen] = useState(false);
  const [isOtpModalOpen, setIsOtpModalOpen] = useState(false);

  const { handleLogin } = useAuth({ setAuthToken, setResetPasswordModalOpen });

  const toggleOtpModal = () => {
    setIsOtpModalOpen(!isOtpModalOpen);
  };

  const handleOtpRequestBlocked = useCallback(() => {
    setIsOtpModalOpen(false);
  }, []);

  const handleOTPValidation = async (otp) => {
    try {
      const response = await validateLoginOTP({ otp, email: userEmail });
      if (response) {
        showSuccessToast(response?.message);
        toggleOtpModal();
        handleLogin(response?.data);
      }
    } catch (error) {
      const errorMessage =
        error?.message || "Something went wrong, please try again.";
      showErrorToast(errorMessage);
      if (
        error?.httpStatus === 403 ||
        OTP_BLOCKED_ERROR_CODES.includes(error?.data?.code)
      ) {
        setAlertMessage(errorMessage);
        handleOtpRequestBlocked();
      }
    }
  };

  const onSubmitLogin = async (email, password, rememberMe) => {
    setLoading(true);
    setUserEmail(email);
    setAlertMessage(null);
    try {
      const { data, message } = await login({ email, password, rememberMe });
      const isAwaitingLoginOTPValidation = !data || false;

      if (isAwaitingLoginOTPValidation) {
        return setIsOtpModalOpen(true);
      }

      handleLogin(data);
      showSuccessToast(message);
    } catch (error) {
      const errorMessage =
        error?.message || "Something went wrong, please try again.";
      setAlertMessage(errorMessage);
      showErrorToast(errorMessage);
    } finally {
      setLoading(false);
    }
  };

  const closeResetPasswordModal = () => {
    setResetPasswordModalOpen(false);
  };

  return (
    <div>
      <LoginForm
        loading={loading}
        alertMessage={alertMessage}
        onSubmitLogin={onSubmitLogin}
      />

      <ChangePasswordModal
        passwordModalOpen={resetPasswordModalOpen}
        closePasswordModal={closeResetPasswordModal}
        authToken={authToken}
        fromLoginPage={true}
        loginUser={onSubmitLogin}
        userEmail={userEmail}
      />

      <OTPModal
        isModalOpen={isOtpModalOpen}
        toggleOtpModal={toggleOtpModal}
        handleOTPValidation={handleOTPValidation}
        setMfaStatus={setIsOtpModalOpen}
        userEmail={userEmail}
        onOtpRequestBlocked={handleOtpRequestBlocked}
      />
    </div>
  );
};

export default Login;
